import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetDataImportProjectsWithReferencesDocument,
  type GetDataImportProjectsWithReferencesQuery,
  type GetDataImportProjectsWithReferencesQueryVariables,
} from "~/features/dataImportProjects/gqls";
import { useTenant } from "~/features/tenant/context";

export function useDataImportProjectList() {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  return useSuspenseQuery<GetDataImportProjectsWithReferencesQuery, GetDataImportProjectsWithReferencesQueryVariables>(
    GetDataImportProjectsWithReferencesDocument,
    { variables: { tenantId } },
  );
}
